<section class="result-item" *ngFor="let item of items">
  <h3 class="channel-title">{{item.ChannelTitle}}</h3>

  <div class="result-item-document" *ngIf="item.IsDocument">
    <app-doc-icon [fileName]="item.Title"></app-doc-icon>
    <span class="document-name" (click)="openDoc(item)" [title]="item.Title">{{getDocTitle(item)}}</span>
    <span class="channel-link" *ngIf="isOpenInChannelVisble(item)" (click)="openInChannel(item)"><svg><use xlink:href="#icon-open-folder-horizontal"></use></svg>Open in Channel</span>
  </div>

  <div class="sub-classification" *ngIf="isItemTitleVisible(item)">
    <app-search-item-title [item]="item" (click)="openInChannel(item)">{{item.ItemTitle}}</app-search-item-title>
  </div>

  <div class="result-item-dates">
    <span class="label">Created on:</span><span class="value">{{item.Created | date: 'longDate'}}</span>
    <span class="label">Last modified on:</span><span class="value">{{item.ModifiedOWSDATE | date: 'longDate'}}</span>
  </div>

  <div class="short-cut" [innerHtml]="getHighlightedSummary(item)"></div>
</section>
